import { render, staticRenderFns } from "./PracticeMembershipPage.vue?vue&type=template&id=f1fbbe64&scoped=true"
import script from "./PracticeMembershipPage.vue?vue&type=script&lang=js"
export * from "./PracticeMembershipPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeMembershipPage.vue?vue&type=style&index=0&id=f1fbbe64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fbbe64",
  null
  
)

export default component.exports